export default "__VITE_ASSET__3HbNI77t__"